import { createFeature, createReducer, on } from '@ngrx/store';
import { ApplicationsListActions } from './applications-list.actions';
import { ApplicationsListFeatureState } from './applications-list.models';

export const initialApplicationsListState: ApplicationsListFeatureState = {
  filters: {
    studentId: null,
    studentLabel: null,
    companyId: null,
    companyLabel: null,
    jobRole: '',
    fromDate: null,
    toDate: null,
    status: true,
    applicationBy: null,
    isRelatable: null
  },
  pagination: {
    firstRowOffset: 0,
    pageSize: 10,
    page: 1,
    totalRecords: 0
  },
  sort: {
    sortField: '',
    sortOrder: 1,
    previousSortField: '',
    previousSortOrder: 0
  },
  gridData: null
};

const reducer = createReducer(
  initialApplicationsListState,
  on(ApplicationsListActions.snapshotPersisted, (state, { snapshot }) => ({
    ...state,
    filters: snapshot.filters,
    pagination: snapshot.pagination,
    sort: snapshot.sort
  })),
  on(ApplicationsListActions.gridDataCached, (state, { gridData }) => ({
    ...state,
    gridData
  })),
  on(ApplicationsListActions.gridDataCleared, (state) => ({
    ...state,
    gridData: null
  })),
  on(ApplicationsListActions.cleared, () => initialApplicationsListState)
);

export const applicationsListFeature = createFeature({
  name: 'applicationsList',
  reducer
});
